import {
  PreviousViewMain,
  PreviousViewContainer,
  PreviousViewHeader,
  PreviousViewContent,
  PreviousViewButtons,
  PreviousViewLoading,
  ObligatoryCellEmpty,
} from "./PreviousView.styles";

import { MdOutlineDocumentScanner } from "react-icons/md";
import { IoCloseSharp } from "react-icons/io5";

import LoadingIcon from "../../../../assets/loading.gif";

import ExcelIcon from "../../../../assets/excel-icon.svg";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";

export function PreviousView({
  categoryName = "Abarrotes|Abarrotes Básicos|Granolas",
  previousViewActive = false,
  setPreviousViewActive = () => {},

  xlsRows = [],
  // Specifies the order of attributes
  /* Example:
    cellPositions : {
      header: 2
      idHeader: 3,
      value: 4
    }
  */
  rowsDataPositions = {
    headers: 0,
    headersIds: 1,
    isDescription: 2,
    obligatories: 3,
    headerType: 6,
    values: 7,
  },
  saveArticlesData = async ({ articles }) => {},
}) {
  const [dataHeaders, setDataHeaders] = useState([]);
  const [dataRows, setDataRows] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(
    "Procesando archivo de excel..."
  );

  const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(false);
  const [buttonSubmitMessage, setButtonSubmitMessage] =
    useState("Guardar cambios");

  function handleClickOutside(e) {
    if (e.target.id === "previous-view") {
      setPreviousViewActive(false);
      handleCleanValues();
    }
  }

  function handleCleanValues() {
    setDataHeaders([]);
    setDataRows([]);
  }

  function RenderData() {
    const {
      headers: headersPosition,
      headersIds: headersIdsPosition,
      isDescription: isDescriptionPosition,
      headerType: headerTypePosition,
      obligatories: obligatoriesPosition,
      values: valuesPosition,
    } = rowsDataPositions;

    xlsRows = xlsRows.map((row) => row?.splice(1));

    // Obtenemos solo el texto de los headers
    const headers = xlsRows[headersPosition];

    //Construimos las rows con su información necesaria vinculada a los headers

    const rows = [];

    xlsRows.forEach((row, rowIndex) => {
      if (rowIndex < valuesPosition) return;

      if (!Array.isArray(row)) return;

      const newRow = row.map((cell, cellIndex) => {
        const headerId = xlsRows[headersIdsPosition][cellIndex]?.value;
        const isDescription = xlsRows[isDescriptionPosition][cellIndex]?.value;
        const headerType = xlsRows[headerTypePosition][cellIndex]?.value;
        const obligatory = xlsRows[obligatoriesPosition][cellIndex]?.value;

        return {
          cellIndex,
          headerId,
          obligatory,
          isDescription,
          type: headerType,
          value: cell ? cell.value : null,
          address: cell ? cell.address : null,
        };
      });

      rows.push(newRow);
    });

    //Liberamos memoria
    xlsRows = [];

    setDataHeaders(headers);
    setDataRows(rows);

    setLoading(false);
  }

  useEffect(() => {
    if (xlsRows.length === 0) return;

    setLoading(true);
    setLoadingMessage("Procesando archivo de excel...");

    const timer = setTimeout(() => {
      RenderData();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [xlsRows]);

  return (
    <PreviousViewMain
      previousViewActive={previousViewActive}
      id="previous-view"
      onClick={handleClickOutside}
    >
      <PreviousViewContainer>
        <PreviousViewHeader>
          <div className="info_container">
            <img src={ExcelIcon} alt="Excel Icon" />

            <div>
              <h2>Vista previa de validación</h2>
              <h4>{categoryName.replaceAll("|", " | ")}</h4>
            </div>
          </div>

          <div
            onClick={() => {
              setPreviousViewActive(false);
              handleCleanValues();
            }}
          >
            <IoCloseSharp size={24} />
          </div>
        </PreviousViewHeader>

        <PreviousViewContent>
          {loading ? (
            <PreviousViewLoading>
              <img src={LoadingIcon} alt="Loading..." />
              <p>{loadingMessage}</p>
            </PreviousViewLoading>
          ) : (
            // <></>
            <TableContainer component={Paper} sx={{ maxHeight: "400px" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {dataHeaders.map((header, index) => (
                      <TableCell
                        sx={{
                          width: "auto",
                          whiteSpace: "nowrap",
                          textTransform: "uppercase",
                          backgroundColor: "#D637A4",
                          color: "#FFF",
                          border: "0.5px solid #fff",
                          position: "sticky",
                          top: 0,
                          left: 0,
                          zIndex: index === 0 ? 2 : 1,
                        }}
                        key={`header-${index}`}
                      >
                        {header?.value}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataRows.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <TableCell
                          sx={{
                            textWrap: "nowrap",
                            border: "0.5px solid rgba(0, 0, 0, 0.1)",
                            position:
                              cell?.cellIndex === 0 ? "sticky" : "unset",
                            left: 0,
                            zIndex: cell?.cellIndex === 0 ? 1 : 0,
                            backgroundColor:
                              cell?.cellIndex === 0
                                ? "#FFF"
                                : cell?.value
                                ? cell.value
                                : cell?.obligatory === "Obligatorio"
                                ? "red"
                                : "unset",
                          }}
                          key={`tableCell-${cellIndex}`}
                        >
                          {cell?.value}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <PreviousViewButtons>
            <button
              className="cancel"
              onClick={() => {
                setPreviousViewActive(false);
                handleCleanValues();
              }}
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                setLoading(true);
                setLoadingMessage("Guardando cambios, por favor espere...");
                setButtonSubmitDisabled(true);
                setButtonSubmitMessage("Guardando...");

                saveArticlesData({
                  articles: dataRows,
                }).finally((_) => {
                  setLoading(false);
                  setButtonSubmitDisabled(false);
                  setButtonSubmitMessage("Guardar cambios");
                });
              }}
              disabled={buttonSubmitDisabled}
            >
              {buttonSubmitMessage}
            </button>
          </PreviousViewButtons>
        </PreviousViewContent>
      </PreviousViewContainer>
    </PreviousViewMain>
  );
}
